import React from 'react';
import { KPICard, LoadingSpinner } from '../../ui';
import { formatNumber } from '../../../utils/formatters';
import { useRefineCustomerResponsesByType } from '../../../hooks/useRefineCustomerQueries';

import { KPIProps } from '../../../types/kpi';
const PositiveResponsesKPI: React.FC<KPIProps> = ({
  branchId = 0,
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data: responsesByType, isLoading, error, refetch } = useRefineCustomerResponsesByType(branchId);

  React.useEffect(() => {
    if (error && onError) {
      onError(error as Error);
    }
  }, [error, onError]);

  if (isLoading && showLoading) {
    return (
      <div className={`${className} animate-enter animate-delay-3`}>
        <div className="card-base card-padding">
          <div className="flex flex-col items-center justify-center h-32">
            <LoadingSpinner
              variant="minimal"
              size="md"
            />
          </div>
        </div>
      </div>
    );
  }

  if (error || !responsesByType) {
    return (
      <div className={`${className} card-base border border-status-error p-4`}>
        <p className="text-status-error text-sm">خطا در بارگذاری درصد نظرات مثبت</p>
        {showLoading && (
          <button
            onClick={() => refetch()}
            className="mt-2 text-xs text-primary-600 hover:text-primary-700"
          >
            تلاش مجدد
          </button>
        )}
      </div>
    );
  }

  const totalResponses = (responsesByType?.['مثبت'] || 0) +
    (responsesByType?.['منفی'] || 0) +
    (responsesByType?.['خنثی'] || 0);

  const positivePercentage = totalResponses > 0
    ? ((responsesByType?.['مثبت'] || 0) / totalResponses * 100).toFixed(1)
    : '0';

  return (
    <div className={`${className} animate-enter-up stagger-2`}>
      <KPICard
        title="درصد دلایل مثبت"
        value={`${positivePercentage}%`}
        subtitle={`${formatNumber(responsesByType?.['مثبت'] || 0)} دلیل`}
        variant="success"
        accentStyle="corner"
      />
    </div>
  );
};

export default PositiveResponsesKPI;